import NativeAd from './NativeAd'

export default NativeAd
